import { navigate, RouteComponentProps } from '@reach/router';
import messages2 from 'containers/LoginPage/messages';
import React, { PureComponent, useRef } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  requireDocument,
  requireProvider,
  requireProviderFn,
  requireProviderTags,
  requireProviderTagsFn,
} from 'store/providers/providerSlice';
import ProfileHead from './ProfileHead/ProfileHead';
import { isNaN } from 'formik';
import { parse } from 'query-string';
import { Helmet } from 'react-helmet';
import { getDomainAndPort } from '../../../api/Utils';
import logo from '../../../assets/images/rastech-logo.png';
import Button from '../../../components/Button/Button';
import LottyLoading from '../../../components/LottyLoading';
import notify from '../../../components/Notify';
import Search from '../../../components/Search';
import AdmitInfoPanel from '../../../custom/AdmitInfoPanel';
import { DataContextProvider } from 'store/context/DataContext';
import { black } from '../../../utils/style/colors';
import {
  BotLogo,
  BotSearch,
  FixedFooter,
  Footer,
  FooterItemContainer,
  FooterName,
  FooterWrapper,
  MobileProfileContainerContentHolder,
  PageFooter,
  PageFooterContent,
  PageFooterItemContainer,
  PageFooterLogo,
  PageFooterLogoContainer,
  RastechLogo,
  SquereFooterLogo,
  StickyPageFooterNavbar,
} from '../../LoginPage/LoginCard/styles';
import TaskItemsViewer from '../../Tasks/TasksManagement/TaskItemsViewer';
import HomeHead from './HomeHead/HomeHead';
import messages from './messages';
import TwoLevelFolderView from './TwoLevelFolderView/TwoLevelFolderView';
import { appDispatch, IThisUser, RootState } from 'store/store';
import {
  IProvider,
  IProviderItems,
  IProviderItemView,
  IProviderItemViewWithData,
  ITags,
} from 'store/providers/providerTypes';
import ViraPage from '../../../components/ChatBot/ViraPage';
import { CampaignImage } from './CampaignImage';
import { UserAvatar } from './ProfileHead/styles';
import { HeaderHome } from './TwoLevelFolderView/styles';
import Icon from '../../../components/Icon/Icon';
import i18n, { languageDirection } from '../../../i18n';
import { ISurveyItem } from '../../../store/survey/surveyTypes';
import MultiTypeModal from '../../../components/Modal/MultiTypeModal';
import styled from 'styled-components';
import { checkFileType } from '../../../utils/check-file-type/check-file-type';
import { ExpandedContainer } from './HorizentalFolderView/styles';
import {
  IHeaderItem,
  WINDOW_WIDTH,
} from '../../../components/Menu/MenuWithBurger';
import { setClipboard } from '../../Tasks/TasksManagement/TaskUtils';
import { getRedirectToLoginLocation } from '../../../utils/happyFunctions';
import SanitizedHTML from 'react-sanitized-html';
import botLogo from 'assets/images/bot-logo.svg';
import defaultFooterIcon from 'assets/images/circle.svg';
import { useScrollDirectionVisibility } from 'hooks/useScrollDirectionVisibility';
import { RefObject } from '@fullcalendar/core/preact';
import Typewriter from 'typewriter-effect';
import {
  toggleWebdaToDarkMode,
  toggleWebdaToLightMode,
} from 'hooks/DarkModeClass';
import DomainFooter from './HorizentalFolderView/DomainFooter';
import { summerizeText } from 'utils/summerizeText';

const ViraFixedContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${(props) => (props.isSelected ? '10000000' : '0')};
  opacity: ${(props) => (props.isSelected ? '1' : '0')};
  transform: scale(${(props) => (props.isSelected ? '1' : '0.5')});
  transition: all 0.5s cubic-bezier(0.61, -0.02, 0.27, 1.26);
`;

const HASH_CHAT = '#chat';
const HASH_MENU = '#menu';

interface IDispatchToProps {
  requireProvider: (
    id: number | string
  ) => ReturnType<typeof requireProviderFn>;
  requireProviderTags: (id: number) => ReturnType<typeof requireProviderTagsFn>;
}

interface IComponentStates {
  loading: boolean;
  showChatbot: boolean;
  isContributor: boolean;
  selectedItem: number | null;
  selectedItemPlaceholder: number | null;
  itemArrangement: Array<{ id: number }>;
  sectionsPosition: { [key: number]: number };
  selectedMoreId: number | null;
  isDesktop: boolean;
}

interface IOwnProps {
  providerId?: string;
  folderId?: string;
  forceSingle?: boolean;
  openItem?: IProviderItemView;
  homeFolder?: number;
  providerNameInURL?: string;
  visible: boolean;
  forwardRef: RefObject<HTMLDivElement> | null;
}

interface IStateToProps {
  provider?: IProvider | null;
  tags?: ITags | null;
  providerItems: IProviderItems;
  thisUser: IThisUser | null;
  companyId: number | null;
  allItems: { [key: number]: IProviderItems };
  rootFolderId: number | undefined;
  pageFooterList: 0 | IProviderItemView[] | undefined;
}

const ContentHolder = styled.div`
  overflow: ${(props) => (props.isItemSelected ? 'hidden' : 'visible')};
  transform: ${(props) => (props.isItemSelected ? 'scale(1.25)' : 'scale(1)')};
  opacity: ${(props) => (props.isItemSelected ? '0' : '1')};
  transition: all 0.5s cubic-bezier(0.61, -0.02, 0.27, 1.26);
  width: 100vw;
  height: 100dvh;
  color: ${black};
`;

type IComponentProps = IDispatchToProps &
  IStateToProps &
  IOwnProps &
  RouteComponentProps;

export function fixModalFootPrint() {
  const modal = document.getElementsByClassName('modal-overlay');
  if (modal.length) {
    modal[0].remove();
  }
  (document.getElementsByTagName('BODY')[0] as HTMLElement).style.overflow =
    'auto';
}

let internalOpenItem = 0;
let documentsPosition = {};
const openItemList: number[] = [];

export const FIXED_FOOTER_TAG = 'conf_footer';
export const CONF_BANNER = 'conf_banner';
export const CONF_ENABLE_SIDEBAR = 'conf_enable_sidebar';

class MobileProfileContainer extends PureComponent<
  IComponentProps,
  IComponentStates
> {
  sectionRef = React.createRef<HTMLDivElement>();
  state = {
    loading: false,
    openItem: undefined,
    showChatbot: false,
    isContributor: false,
    selectedItem: null,
    selectedItemPlaceholder: null,
    itemArrangement: [],
    sectionsPosition: {},
    selectedMoreId: null,
    isDesktop: window.innerWidth > WINDOW_WIDTH,
  };

  handlePopState = () => {
    internalOpenItem--;
    this.syncModalStateWithUrl();
  };

  syncModalStateWithUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('modal')) {
      const modalId = Number(params.get('modal'));
      if (this.state.selectedItem !== modalId) {
        this.handleSelectedItem(modalId);
      }
      return;
    }

    if (this.state.selectedItem) {
      this.handleSelectedItem(null);
    }
  };

  componentDidMount(): void {
    this.loadProvider();
    window.addEventListener('popstate', this.handlePopState);
    if (window.location.hash.startsWith(HASH_CHAT)) {
      this.setState({ showChatbot: true });
    } else {
      this.setState({ showChatbot: false });
    }

    const isWebdaThemeDark = localStorage.getItem('webda-dark-mode') === 'true';
    if (isWebdaThemeDark) {
      toggleWebdaToDarkMode();
    } else {
      toggleWebdaToLightMode();
    }

    if (
      this.props?.folderId &&
      !window.location.pathname?.includes(this.props.folderId?.toString()) &&
      this.props.pageFooterList &&
      this.props.pageFooterList?.length
    ) {
      const folderId = this.props.folderId;
      const url = this.handleGetBaseUrl();
      navigate(`${url}/f/${folderId}`);
    }

    window.addEventListener('resize', this.calculateWindowSize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateWindowSize.bind(this));
    window.removeEventListener('popstate', this.handlePopState);
  }

  calculateWindowSize = () => {
    this.setState({ isDesktop: window.innerWidth > WINDOW_WIDTH });
  };

  scrollToRef = () => {
    setTimeout(() => {
      this.props.forwardRef?.current?.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 250);
  };

  componentDidUpdate(
    prevProps: Readonly<IComponentProps>,
    prevState: Readonly<IComponentStates>
  ): void {
    if (prevProps.folderId !== this.props.folderId) {
      this.scrollToRef();
    }
    if (
      !this.props.provider &&
      prevProps.providerId !== this.props.providerId
    ) {
      this.loadProvider();
    }

    if (!this.props.openItem && prevProps.openItem) {
      fixModalFootPrint();
    }

    if (this.props.openItem && this.state.showChatbot) {
      this.setState({ showChatbot: false });
    }

    if (this.state.showChatbot !== prevState.showChatbot) {
      if (this.state.showChatbot) {
        window.location.hash = HASH_CHAT;
      }
    }

    if (window.location.hash !== HASH_CHAT && this.state.showChatbot) {
      this.setState({ showChatbot: false });
    }

    if (window.location.hash === HASH_CHAT && !this.state.showChatbot) {
      this.setState({ showChatbot: true });
    }

    if (
      openItemList.length > 0 &&
      openItemList.slice(-1)[0] !== Number(this.props.folderId) &&
      !this.state.loading &&
      this.state.itemArrangement.length > 1 &&
      prevState.selectedItem === null &&
      window.location.hash !== HASH_MENU
    ) {
      if (
        Object.keys(this.state.sectionsPosition).includes(
          String(openItemList.slice(-1)[0])
        )
      ) {
        this.props.forwardRef?.current?.scrollTo({
          top: Number(this.state.sectionsPosition[openItemList.slice(-1)[0]]),
          behavior: 'smooth',
        });
      } else {
        this.props.forwardRef?.current?.scrollTo({
          top: Number(documentsPosition[openItemList.slice(-1)[0]]),
          behavior: 'smooth',
        });
      }
      openItemList.pop();
    } else if (window.location.hash === HASH_MENU) {
      window.location.hash = '';
    }

    this.syncModalStateWithUrl();

    const params = new URLSearchParams(location.search);
    if (params.has('more')) {
      const moreId = Number(params.get('more'));
      const arrangedMoreId = (
        this.state.itemArrangement as Array<{ id: number }>
      )[0]?.id;
      if (
        this.state.itemArrangement.length !== 1 ||
        arrangedMoreId !== moreId ||
        this.state.selectedMoreId !== moreId
      ) {
        this.handleSetItemArrangement([{ id: moreId }]);
        this.handleSelectedMoreId(moreId);
      }
    }
  }

  handleSelectedMoreId = (id: number | null) => {
    this.setState({ selectedMoreId: id });
  };

  handleChangeChatbotStatus = (openOrClose: boolean) => {
    this.setState({
      showChatbot: openOrClose,
    });
  };

  handleChangeContributionStatus = (status: boolean) => {
    this.setState({
      isContributor: status,
    });
  };

  handleOpenItem = (item: IProviderItemView) => {
    const domain = getDomainAndPort();
    documentsPosition = {
      ...documentsPosition,
      [item.id]:
        (this.props.forwardRef?.current?.scrollTop || 0) -
        (window.innerWidth < 600 ? 0 : 0.9) * window.innerHeight,
    };
    if (item.type === 'externalLink') {
      window.open(item.url, '_blank');
    } else if (item.type === 'link') {
      internalOpenItem++;
      navigate(`/${item.username || item.linkedProviderId}`);
    } else if (item.type === 'folder') {
      openItemList.push(item.id);
      internalOpenItem++;
      const homeProfileId = domain?.homeProfile;
      if (
        homeProfileId === this.props?.providerId &&
        location.href.includes(this.props.providerNameInURL || '')
      ) {
        navigate(`/${this.props.providerNameInURL}/f/${item.id}`);
      } else
        navigate(
          `/${this.props.provider!.username || this.props.provider!.id}/f/${
            item.id
          }`
        );
    } else {
      if (window.location.pathname.includes('/direct/')) {
        navigate(
          window.location.pathname.substring(
            0,
            window.location.pathname.lastIndexOf('/') + 1
          ) + item.id
        );
      } else {
        internalOpenItem++;
        navigate(`${window.location.pathname}?item=${item.id}`, {
          replace: window.location.search.includes('item'),
        });
      }
    }
  };

  handleCloseItem = (_: IProviderItemViewWithData | null) => {
    if (!internalOpenItem) {
      navigate(window.location.pathname);
    } else {
      history.back();
    }
  };

  loadProvider = () => {
    this.setState({ loading: true });
    const id = this.props.providerId;
    const domainAndPort = getDomainAndPort();
    const showAdminInfo =
      domainAndPort.domainFeatures?.showAdminInfoOnProfile === (id || -1);
    this.props.requireProvider(id ? id : this.props.providerNameInURL!).then(
      () => {
        this.setState({ loading: false });
      },
      (e) => {
        if (e.code < 500 && e.code > 400)
          window.location.href = getRedirectToLoginLocation();
        else {
          notify(messages.networkError, 'error');
          this.setState({ loading: false });
        }
      }
    );
    if (showAdminInfo) this.props.requireProviderTags(Number(id));
  };

  openNextItem = () => {
    const currentItemId = this.props.openItem?.id;
    if (!currentItemId) return;
    const currentItemOrder = this.props.openItem!.order;
    const currentItemDad = this.props.openItem!.dadId;
    let nextCondidateId: number | undefined = undefined;
    let nextCondidateOrder: number | undefined = undefined;
    let nextItem: any = undefined;
    Object.values(this.props.providerItems.items).forEach((item) => {
      const itemOrder = item.data.order;
      const itemId = item.data.id;
      if (
        item.data.dadId === currentItemDad &&
        (itemOrder > currentItemOrder ||
          (itemOrder === currentItemOrder && itemId > currentItemId))
      ) {
        if (
          !nextCondidateId ||
          nextCondidateOrder! > itemOrder ||
          (nextCondidateId === itemOrder && nextCondidateId > itemId)
        ) {
          nextCondidateId = itemId;
          nextCondidateOrder = itemOrder;
          nextItem = item.data;
        }
      }
    });
    if (nextItem) this.handleOpenItem(nextItem);
    else this.handleCloseItem(null);
  };

  handleSelectedItem = (id: number | null) => {
    if (!id) {
      this.setState({
        selectedItemPlaceholder: this.state.selectedItem,
      });
      setTimeout(() => {
        this.setState({
          selectedItemPlaceholder: null,
        });
      }, 1000);
    }
    this.setState({
      selectedItem: id,
    });
  };

  handleResetItemArrangement = (
    items: IProviderItemView[],
    withBack: boolean = true
  ) => {
    if (withBack) {
      history.back();
    }
    const newArrangement =
      items &&
      items
        .sort((a, b) => a.order - b.order)
        .filter(
          (a) =>
            (a.type === 'folder' || a.type === 'searchTag') &&
            !a.tags.some((tag) => tag.text.toLowerCase() === 'conf_hidden')
        )
        .map((item) => ({
          id: item.id,
        }));

    setTimeout(() => {
      this.setState({ itemArrangement: newArrangement, selectedMoreId: null });
    }, 100);
  };

  handleSelectSpecificItemForArrangement = (item: { id: number }) => {
    openItemList.push(item.id);
    this.setState({
      sectionsPosition: {
        ...this.state.sectionsPosition,
        [item.id]:
          (this.props.forwardRef?.current?.scrollTop || 0) -
          (window.innerWidth < 600 ? 0 : 0.3) * window.innerHeight,
      },
      itemArrangement: [item],
      selectedMoreId: item.id,
    });
    const params = new URLSearchParams(location.search);
    params.set('more', String(item.id));
    navigate(`${location.pathname}?${params.toString()}`);
  };

  handleSetItemArrangement = (items: Array<{ id: number }>) => {
    this.setState({ itemArrangement: items });
  };

  handleCloseModal = () => {
    if (this.state.selectedItem) {
      setTimeout(() => {
        this.handleSelectedItem(null);
      }, 250);
      const params = new URLSearchParams(location.search);
      if (params.has('modal')) {
        history.back();
      }
    }
  };

  handleGetBaseUrl = () => {
    const domain = getDomainAndPort();
    const homeProfileId = domain?.homeProfile;

    const urlProviderId =
      homeProfileId === this.props.providerId &&
      location.href.includes(this.props.providerNameInURL || '')
        ? this.props.providerNameInURL
        : this.props.providerId || this.props.provider?.id;

    if (this.props.providerNameInURL) return `/${this.props.providerNameInURL}`;

    return `/${urlProviderId}`;
  };

  handleNavigateToFolder = (id: number) => {
    const url = this.handleGetBaseUrl();
    this.setState({ selectedMoreId: null });
    if (this.props?.folderId && Number(this.props.folderId) !== id) {
      navigate(`${url}/f/${id}`);
    }
  };

  handleSetInitialItemArrangement = (rootFolderId: number) => {
    const { allItems, provider } = this.props;
    this.setState({
      itemArrangement: Object.values(allItems[provider!.id].items)
        .filter((item) => item.data.dadId === rootFolderId)
        .map((el) => el.data),
    });
  };

  render() {
    const {
      provider,
      folderId,
      forceSingle,
      openItem,
      tags,
      thisUser,
      companyId,
      allItems,
      providerItems,
      homeFolder,
      rootFolderId,
      pageFooterList,
    } = this.props;
    const {
      loading,
      selectedItem,
      selectedItemPlaceholder,
      selectedMoreId,
      isDesktop,
    } = this.state;
    const domainAndPort = getDomainAndPort();
    const onHomePage =
      domainAndPort.domainFeatures?.showAdminInfoOnProfile ===
      (provider?.id || -1);

    // const onProviderHome =
    //   domainAndPort.domainFeatures?.showCampaignImageExport ===
    //   (provider?.id || -1);
    const campaignSurvey = this.props.providerItems?.items?.[281965]?.data;
    let selectedItemData = null;

    if ((selectedItem || selectedItemPlaceholder!) && provider?.id) {
      selectedItemData =
        allItems[provider.id]?.items[selectedItem || selectedItemPlaceholder!]
          ?.data;
    }

    if ((selectedItem || selectedItemPlaceholder) && provider) {
      selectedItemData =
        allItems[provider.id].items?.[selectedItem || selectedItemPlaceholder!]
          ?.data;
    }

    // @todo chekck
    // const isMenuEnabled =
    //   domainAndPort.domainFeatures?.enableMenu ||
    //   (provider &&
    //     allItems[provider!.id]?.items[rootFolderId!]?.data?.tags.find(
    //       (tag: ITagView) => tag.text === CONF_ENABLE_SIDEBAR
    //     ));

    const isCustomFooterEnabled =
      domainAndPort.domainFeatures?.enableCustomFooter;

    const headerList =
      provider?.id &&
      Object.values(allItems[provider.id].items)
        .filter((item) => item.data.dadId === rootFolderId)
        .filter(
          (item) =>
            !item.data.tags.some((it) => it.text === 'CONF_HIDDEN') &&
            (item.data.formatedName || item.data.name?.trim() || '')?.length > 0
        )
        .map((el) => el.data)
        .sort((a, b) => a.order - b.order)
        .reduce((acc: IHeaderItem[], item) => {
          if (item.viewType?.split(',')?.includes('display_shine')) {
            const shineItems = Object.values(providerItems.items)
              .sort((a, b) => a.data.order - b.data.order)
              .filter((el) => el.data.dadId === item.id)
              .map((el) => ({
                id: el.data.id,
                title: el.data.formatedName || el.data.name,
                isShine: true,
                tags: item?.tags || [],
                logo: el.data.thumbnailUrl,
              }));
            acc.push(...shineItems);
          } else {
            acc.push({
              id: item.id,
              title: item.formatedName || item.name,
              isShine: false,
              tags: item?.tags || [],
              logo: item.thumbnailUrl,
            });
          }
          return acc;
        }, []);

    const enableChatBot =
      this.props.provider?.botProperties?.enableBotIntegration;

    const disableBackWhileMoreIsEnabled =
      folderId &&
      folderId !== homeFolder?.toString() &&
      parse(window.location.search)?.more;

    const isPageFooterEnabled = pageFooterList
      ? pageFooterList?.length > 1
      : false;

    const isChildOfRootFolder =
      provider?.id &&
      Object.values(allItems[provider.id].items)?.find(
        (el) =>
          el.data.dadId === rootFolderId && Number(folderId) === el.data.id
      )?.data;

    const fixedFooterList = (headerList || []).filter((item: IHeaderItem) =>
      item.tags.find((tag) => tag.text === FIXED_FOOTER_TAG)
    );

    return provider ? (
      <div
        style={{ overflow: 'hidden' }}
        ref={this.sectionRef}
        id="top-element"
      >
        <MultiTypeModal
          isOpen={selectedItem !== null}
          onClose={this.handleCloseModal}
          contentType={
            selectedItemData
              ? checkFileType(selectedItemData?.document.properties.format)
              : 'document'
          }
          data={selectedItemData}
          logo={
            selectedItemData
              ? allItems[provider.id].items[selectedItemData.dadId].data
                  .thumbnailUrl
              : ''
          }
          logoName={
            selectedItemData
              ? ((allItems[provider.id].items[selectedItemData.dadId].data
                  .formatedName ||
                  allItems[provider.id].items[selectedItemData.dadId].data
                    .name) as string)
              : ''
          }
        />
        <ViraFixedContainer isSelected={this.state.showChatbot}>
          <ExpandedContainer isSelected={this.state.showChatbot}>
            <ViraPage
              provider={provider!}
              companyId={companyId}
              onCloseChatbot={this.handleChangeChatbotStatus}
            />
          </ExpandedContainer>
        </ViraFixedContainer>
        <div style={{ position: 'relative' }}>
          {openItem && (
            <DataContextProvider value={{ providerId: provider.id }}>
              <TaskItemsViewer
                dispatch={appDispatch}
                onClose={this.handleCloseItem}
                openItem={{ data: openItem as any }}
                openNextItem={this.openNextItem}
                showAnimation={true}
              />
            </DataContextProvider>
          )}
        </div>
        <ContentHolder
          isItemSelected={
            this.state.selectedItem !== null ||
            this.props.openItem ||
            this.state.showChatbot
          }
        >
          {/* {isMenuEnabled && (
            <MenuWithBurger
              itemList={headerList as IHeaderItem[]}
              provider={provider}
              allItems={allItems[provider.id]}
              homeFolder={homeFolder}
              onResetItemArrangement={() =>
                this.handleResetItemArrangement(
                  Object.values(allItems[provider.id].items)
                    .filter((item) => item.data.dadId === rootFolderId)
                    .map((el) => el.data)
                )
              }
              providerId={this.props.providerId}
              providerNameInURL={this.props.providerNameInURL}
            />
          )} */}
          {campaignSurvey && (
            <CampaignImage
              onClose={() => this.handleChangeContributionStatus(false)}
              active={this.state.isContributor}
              surveyItem={campaignSurvey as ISurveyItem}
            />
          )}
          <div
            style={{
              display: 'block',
              overflow: openItem ? 'hidden' : 'auto',
              overflowX: 'hidden',
              height: '100dvh',
              width: '100vw',
            }}
            className={`relative w-full ${!this.state.showChatbot ? 'mobileViewContent-active' : 'mobileViewContent-inactive'}`}
            ref={this.props.forwardRef}
          >
            <div className="overflow-auto">
              <Helmet>
                <title>{provider.name}</title>
                <meta name="description" content={provider.name} />
              </Helmet>
              <MobileProfileContainerContentHolder
                hasFixedFooter={fixedFooterList?.length}
              >
                {onHomePage ? (
                  <div
                    style={{
                      minHeight: onHomePage ? '200px' : '',
                      display: 'inline-table',
                      width: '100%',
                    }}
                  >
                    <HomeHead provider={provider} small={!!folderId} />
                    <Search />
                  </div>
                ) : isChildOfRootFolder ? (
                  <div
                    style={{
                      minHeight: onHomePage ? '200px' : '',
                      width: '100%',
                    }}
                  >
                    <ProfileHead
                      provider={provider}
                      onChangeChatbotStatus={this.handleChangeChatbotStatus}
                      onChangeContributionStatus={
                        this.handleChangeContributionStatus
                      }
                      thisUser={thisUser}
                      companyId={this.props.companyId as number}
                      rootFolderId={rootFolderId}
                      childOfRootFolder={isChildOfRootFolder}
                    />
                  </div>
                ) : (
                  <>
                    {!disableBackWhileMoreIsEnabled && (
                      <div
                        style={{
                          minHeight: onHomePage ? '200px' : '',
                          display: 'inline-table',
                          width: '100%',
                          position: 'sticky',
                          top: 0,
                          left: 0,
                          zIndex: 99999,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '20px 30px 10px',
                          }}
                        >
                          <Helmet>
                            <title>
                              {folderId
                                ? this.props.providerItems.items?.[
                                    Number(folderId)
                                  ]?.data.name
                                : ''}
                            </title>
                          </Helmet>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              width: '80%',
                              alignItems: 'center',
                              margin: '2rem auto',
                            }}
                          >
                            <Button
                              onClick={() => {
                                history.back();
                              }}
                            >
                              <Icon
                                type={
                                  languageDirection() === 'rtl'
                                    ? 'arrow-right'
                                    : 'arrow-left'
                                }
                                style={{ marginLeft: '5px' }}
                              />
                              {i18n.t('back', { ns: 'landingPage' }) as string}
                            </Button>
                            <HeaderHome
                              onClick={() => {
                                //   if (!internalOpenItem) {
                                //     navigate('/');
                                //   } else {
                                //     internalOpenItem--;
                                //     // backedFolder = true;
                                //     history.back();
                                //   }
                              }}
                            >
                              {}
                            </HeaderHome>
                            <Button
                              onClick={() => {
                                try {
                                  navigator.share({
                                    title:
                                      (this.props.providerItems.items?.[
                                        Number(folderId)
                                      ].data?.name || '') + '\n #نه_به_تصادف',
                                    url: window.location.href,
                                  });
                                  setClipboard(window.location.href);
                                  if (isDesktop) {
                                    notify(messages.copyToClipboard);
                                  }
                                } catch (error) {
                                  /*do nothing*/
                                }
                              }}
                            >
                              {i18n.t('share', { ns: 'modals' }) as string}
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                    {folderId &&
                      !!this.props.providerItems.items?.[Number(folderId)]?.data
                        ?.thumbnailUrl && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                          }}
                        >
                          <UserAvatar
                            src={
                              this.props.providerItems.items?.[Number(folderId)]
                                ?.data?.thumbnailUrl
                            }
                            alt="avatar"
                          />
                        </div>
                      )}
                  </>
                )}

                {onHomePage &&
                  !folderId &&
                  tags &&
                  tags.status === 'loaded' && (
                    <AdmitInfoPanel provider={provider} />
                  )}

                {provider.rootDocument && (
                  <TwoLevelFolderView
                    providerId={provider.id}
                    folderId={folderId ? Number(folderId) : rootFolderId}
                    onOpen={this.handleOpenItem}
                    forceSingle={
                      forceSingle ||
                      (folderId &&
                        this.props.providerItems.items[Number(folderId)] &&
                        this.props.providerItems.items[
                          Number(folderId)
                        ]?.data?.viewType
                          ?.split(',')
                          .includes('display_shine'))
                    }
                    provider={provider}
                    selectedItem={selectedItem}
                    onSelectedItem={this.handleSelectedItem}
                    itemArrangement={this.state.itemArrangement}
                    onResetItemArrangement={this.handleResetItemArrangement}
                    onSelectSpecificItemForArrangement={
                      this.handleSelectSpecificItemForArrangement
                    }
                    onSetItemArrangement={this.handleSetItemArrangement}
                    folderShowBack={folderId}
                    selectedMoreId={selectedMoreId}
                    rootFolderId={rootFolderId}
                  />
                )}
                {isCustomFooterEnabled ? (
                  <DomainFooter provider={provider} />
                ) : (
                  <></>
                )}
                <Footer isPageFooterEnabled={isPageFooterEnabled}>
                  <a
                    href={messages2.rastechSite}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <RastechLogo src={logo} small={true} />
                    <span style={{ padding: '0px 10px ', color: black }}>
                      {i18n.t('copyright', { ns: 'general' }) as string}
                    </span>
                    {messages.footerNote}
                  </a>
                </Footer>
              </MobileProfileContainerContentHolder>

              {(fixedFooterList || [])?.length ? (
                <FixedFooter>
                  {enableChatBot && (
                    <BotSearch
                      visible={this.props.visible}
                      onClick={() => this.handleChangeChatbotStatus(true)}
                    >
                      <div>
                        <Typewriter
                          options={{
                            strings:
                              provider.botProperties?.chatButtonTitle ||
                              messages.needHelp,
                            delay: 10,
                            autoStart: this.props.visible,
                            loop: true,
                          }}
                        />
                      </div>

                      <BotLogo src={botLogo} />
                    </BotSearch>
                  )}
                  <FooterWrapper>
                    {fixedFooterList?.map((item: IHeaderItem) => {
                      return (
                        <FooterItemContainer
                          key={item.id}
                          onClick={() => {
                            // reset Arrangement
                            const parsed = parse(window.location?.search);
                            if (parsed?.more) {
                              this.handleResetItemArrangement(
                                Object.values(allItems[provider.id].items)
                                  .filter(
                                    (item) => item.data.dadId === rootFolderId
                                  )
                                  .map((el) => el.data),
                                false
                              );
                            }
                            navigate('/');
                            setTimeout(() => {
                              document
                                .getElementById(`${item.id}`)
                                ?.scrollIntoView({ behavior: 'smooth' });
                            }, 400);
                          }}
                        >
                          <SquereFooterLogo
                            className="glass-card"
                            src={item.logo || defaultFooterIcon}
                            // src={botLogo}
                          />

                          <FooterName className="glass-card">
                            {/* {summerizeText(item.title, 5)} */}
                            <SanitizedHTML
                              allowedAttributes={{ span: ['style'] }}
                              html={item.title}
                            />
                          </FooterName>
                        </FooterItemContainer>
                      );
                    })}
                  </FooterWrapper>
                </FixedFooter>
              ) : (
                <></>
              )}
            </div>
          </div>
          {isPageFooterEnabled && (
            <StickyPageFooterNavbar>
              <PageFooter>
                {pageFooterList &&
                  pageFooterList?.map((folder: IProviderItemView) => (
                    <PageFooterItemContainer
                      key={folder.id}
                      onClick={() => this.handleNavigateToFolder(folder.id)}
                      isActive={
                        this.props.folderId
                          ? folder.id === Number(this.props.folderId)
                          : false
                      }
                    >
                      <PageFooterLogoContainer>
                        <PageFooterLogo src={folder?.thumbnailUrl} />
                      </PageFooterLogoContainer>
                      <PageFooterContent>
                        {summerizeText(folder.name, 10)}
                      </PageFooterContent>
                    </PageFooterItemContainer>
                  ))}
              </PageFooter>
            </StickyPageFooterNavbar>
          )}
        </ContentHolder>
      </div>
    ) : loading ? (
      <LottyLoading />
    ) : (
      <div>
        <p>{messages.networkError}</p>
        <Button onClick={this.loadProvider}> {messages.tryAgain} </Button>
      </div>
    );
  }
}

function MobileProfileWrapper(props: any) {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useScrollDirectionVisibility({
    scrollRef: ref,
  });

  return (
    <MobileProfileContainer {...props} visible={visible} forwardRef={ref} />
  );
}

const mapStateToProps: MapStateToProps<
  IStateToProps,
  IOwnProps & RouteComponentProps,
  RootState
> = (state, props) => {
  const thisUser = state.thisUser;
  const domain = getDomainAndPort();
  const mapRoutes = domain?.mapRoutes;
  let pid = Number(props.providerId);
  let homeFolder = domain.homeFolder;
  if (isNaN(pid)) {
    if (Object.keys(mapRoutes || {}).includes(props.providerId || '')) {
      homeFolder = Number(mapRoutes![props.providerId!]);
      pid = domain.homeProfile!;
    } else pid = state.providers.usernameMap[props.providerId!];
  }
  let item = undefined;
  if (location) {
    const parsed = parse(location.search);
    if (parsed.item) {
      item = state.providers.items[pid]?.items[Number(parsed.item)]?.data;
      if (!item) {
        appDispatch(requireDocument({ documentId: Number(parsed.item) })).then(
          (data: any) => (item = data.item)
        );
      }
    }
  }

  const provider = state.providers.map[pid]?.data;
  const providerItems = state.providers.items[pid];
  const tags = state.providers.tags[pid];
  const companyId = state.providers.map[pid]?.data?.managingCompanyId as number;
  const allItems = state.providers.items;

  const rootFolderId = homeFolder
    ? homeFolder
    : provider?.rootDocument.id &&
      providerItems?.items?.[provider.rootDocument.id]?.data.id;

  const pageFooterList =
    provider?.id &&
    Object.values(allItems[provider.id].items)
      .filter(
        (item) =>
          item.data.dadId === rootFolderId && item.data.type === 'folder'
      )
      .filter(
        (item) =>
          !item.data.tags.some((it) => it.text === 'CONF_HIDDEN') &&
          (item.data.formatedName || item.data.name?.trim() || '')?.length > 0
      )
      .map((el) => el.data)
      .sort((a, b) => a.order - b.order);

  const folderId = props.folderId
    ? props.folderId
    : pageFooterList
      ? pageFooterList.at(0)?.id
      : false;

  return {
    provider: provider,
    openItem: item,
    tags,
    providerItems,
    thisUser,
    companyId,
    allItems,
    homeFolder,
    providerId: pid,
    providerNameInURL: props.providerId,
    rootFolderId,
    pageFooterList,
    folderId: folderId,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  RouteComponentProps
> = () => {
  return {
    requireProvider: (id: number | string) =>
      appDispatch(requireProvider({ providerId: id })),
    requireProviderTags: (id: number) =>
      appDispatch(requireProviderTags({ providerId: id })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(MobileProfileWrapper);
